<!-- 首营客户历史 -->
<template>
	<div class='page_content'>
		<processAuditAction ref="processAuditAction"></processAuditAction>
		<subComponents @selectDataAction="selectDataAction" ref="showSelectData"></subComponents>
		<div class="page_content_top">
			<div class="page_content_top_line">
				<el-button type="primary" size="mini" @click="actionSet(buttonValue)"
					v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
					{{buttonValue.jurName}}
				</el-button>
				<el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">
					刷新
				</el-button>
			</div>
			<div class="page_content_top_line">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData.jurHead" @submit.native.prevent
					size="mini">
					<el-form-item :label="formOneValue.showField" 
						v-for="(formOneValue,formOneKey) in pageShowData.jurHead.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow==1">
						<template>
							<el-input v-if="formOneValue.entityField == 'bgmId'"
							@focus="openSearch(formOneValue.searchId, 0, 'bgmId')" v-model="sendDataInfo.bgmName"
							v-model.trim="getRequestData.bgmName" clearable :maxlength="$store.state.inputLength">
						</el-input>
						<el-date-picker v-else-if="formOneValue.entityField == 'start'" size="mini"
							v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
							value-format="timestamp" type="date" placeholder="选择日期">
						</el-date-picker>
						<el-date-picker v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini"
							v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
							value-format="timestamp" type="date" placeholder="选择日期">
						</el-date-picker>
                        <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                            <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                                :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
						<el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" size="mini"
							:maxlength="$store.state.inputLength"></el-input>
						</template>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" size="mini" @click="searchData">查询</el-button>
					</el-form-item>

				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" height="100%" border
				style="width: 100%" highlight-current-row>
				<el-table-column label="选择操作" width="90">
					<template slot-scope="scope">
						<el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
							<i class="el-icon-thumb"></i>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column 
					v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable"
					:min-width="tableValye.fieldWeight" show-overflow-tooltip :key="tableKey"
					:prop="tableValye.entityField" :label="tableValye.showField"  v-if="tableValye.isShow==1" >
					<template slot-scope="scope">
						<div v-if="tableValye.entityField == 'cliRedate'">
							<span v-if="scope.row[tableValye.entityField]">
								{{$common.getLocalTime(scope.row[tableValye.entityField])}}
							</span>
						</div>
						<div v-else-if="tableValye.entityField == 'cliTervalidity'">
							<span v-if="scope.row[tableValye.entityField]">
								{{$common.getLocalTime(scope.row[tableValye.entityField])}}
							</span>
						</div>
						<div v-else-if="tableValye.entityField == 'cliStatus'">
							<el-tag size="mini" type="primary">
								{{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
						</div>
						<div v-else-if="tableValye.entityField == 'isUsed'">
							<el-tag size="mini" type="primary">
								{{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
						</div>
						<div v-else-if="tableValye.entityField == 'isIntercept'">
							<el-tag size="mini" type="primary">
								{{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
						</div>
						<div v-else>
							{{scope.row[tableValye.entityField]}}
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
				:current-page="getRequestData.page" :page-sizes="[30,50,100,500]" :page-size="30"
				layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
			</el-pagination>
		</div>
		<el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
			<SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
				@TranData="changeInputModel" />
		</el-dialog>
		<!-- 自定义设计 -->
		<customDesign ref="customDesign"></customDesign>
	</div>
</template>
<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import SearchScheme from "../../../byComponents/SearchScheme.vue";
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {
			SearchScheme,
		},
		data() {
			//这里存放数据
			return {
				getRequestData: {
					bgmId: "",
					bgmName: "",
					cmName: '',
					page: 1,
					rows: 30,
				},
				returnData: {
					pages: 0, // 总页数
					total: 0, // 总条数
					pageNum: 0, // 当前页数
					list: [],
				},
				buttonList: [],

				pageShowData: [],
				selectedDataIndex: 0,
				parentSearchData: {
					smId: "",
				},
				DialogVisible: false,
				seId: "",
				seIndex: "",
				seType: "",
				seWidth: "",
				seTitle: "",
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {
			"getRequestData.bgmName": {
				handler: function (newValue, oldValue) {
					if (newValue == "") {
						this.getRequestData.bgmId = "";
					}
				},
				deep: true,
			},
		},
		//方法集合
		methods: {
			changeTime(val) {
				if (val) {
					var time = val + 24 * 60 * 60 * 1000 - 1;
					this.getRequestData.end = time;
				}
			},
			// 检索Id, 索引(表格中), 标识
			openSearch(sId, index, type) {
				if (type == "salesId") {}
				this.DialogVisible = true;
				this.seId = sId;
				this.seIndex = index;
				this.seType = type;
			},
			changeInputModel(val) {
				console.log(val);
				console.log(this.seType);
				if (val != "" || val != undefined) {
					this.DialogVisible = false;
					if (this.seType == "bgmId") {
						this.getRequestData.bgmId = val.bgmId;
						this.getRequestData.bgmName = val.bgmName;
					}
					console.log();
				}
				// this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex].bgmName = val.bgmName
			},
			//获取状态
			getIsGsp(str, val) {
				try {
					str && str.replace(/\\/g, "");
					let arr = JSON.parse(str);
					let len = arr.length;
					let newStr = "";
					for (let i = 0; i < len; i++) {
						if (arr[i].key == val) {
							newStr = arr[i].value;
							break;
						}
					}
					return newStr;
				} catch (ex) {
					return str;
				}
			},
			selectDataAction(selectedData = {}, name, value) {
				switch (name) {
					case "bgmId":
						this.getRequestData.bgmId = selectedData.bgmId;
						this.getRequestData.bgmName = selectedData.bgmName;
						break;

					default:
						this.getRequestData[name] = value;
				}
			},

			// 获取数据列表
			async getPageInfo() {
				var pathId = parent.getMenuInfo(this.$route.path);
				let responseData = await this.$http.getJur({
					ids: [pathId.jurId]
				});
				if (responseData.status == 200) {
					this.getButtonList();
					this.pageShowData = responseData.result;
					this.getDataList();
				} else {
					this.$message({
						message: responseData.message,
						type: "error",
					});
				}
			},

			// 动作集合
			actionSet(actionData) {
				if (actionData.actionType != 15) {
					var dataInfo = this.returnData.list[this.selectedDataIndex];
					if (!dataInfo) {
						this.$message({
							message: "请先选中要操作的数据",
							type: "error",
						});
						return false;
					}
				}
				switch (actionData.actionType) {
					case 1:
						this.$refs["processAuditAction"].openBox(0, dataInfo.cliId);
						break;
					case 3:
						this.$refs["processAuditAction"].openBox(1, dataInfo.cliId);
						break;
					case 15:
						this.openFormDesign()
						break;
				}
			},
			openFormDesign() {
				let pathInfo = parent.getMenuInfo(this.$route.path)
				this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
			},
			// 数据搜索
			searchData() {
				this.getRequestData.page = 1;
				this.getDataList();
			},
			// 数据翻页
			setDataPageNumber(val) {
				this.getRequestData.page = val;
				this.getDataList();
			},

			// 切换显示条数
			setDataPageSize(val) {
				this.getRequestData.page = 1;
				this.getRequestData.rows = val;
				this.getDataList();
			},

			// 获取数据列表
			async getDataList() {
				let responseData =
					await this.$http.gspCustomerqueryCuslicenceLinfonoteHistory(
						this.getRequestData
					);
				if (responseData.status == 200) {
					this.returnData.list = responseData.result.list;
					this.returnData.pages = responseData.result.pages;
					this.returnData.total = responseData.result.total;
					this.returnData.pageNum = responseData.result.pageNum;
					this.selectedDataIndex = 0;
				} else {
					this.$message({
						message: responseData.message,
						type: "error",
					});
				}
			},

			// 获取按钮权限
			async getButtonList() {
				this.buttonList = await this.$common.getActionButton()
				
			},
},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.getPageInfo();
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
},
		beforeCreate() {}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style scoped>
	.table_content_tag {
		margin-right: 1rem;
	}

	.el-tabs--border-card_new {
		height: 85vh;
		overflow-y: scroll;
	}
</style>